import React, { useEffect, useMemo, useState } from "react";
import VideoList from "../components/VideoList";
import VideoPlayer from "../components/VideoPlayer";
import { setPageMeta } from "../seo/setPageMeta";

export default function Videos() {
  const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

  const [videos, setVideos] = useState([]);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(false);

  useEffect(() => {
    setPageMeta({
      title: "Guest Speaker Videos | Celebrate Recovery Independence KY",
      description:
        "Watch guest speaker videos and browse the Celebrate Recovery video library in Independence, Kentucky.",
      canonical: "https://www.crindependenceky.com/videos",
    });

    fetchVideos();
  }, []);

  async function fetchVideos() {
    try {
      const response = await fetch(`${API_URL}/api/videos`);
      const data = await response.json();

      const normalizedVideos = Array.isArray(data) ? data : [];
      setVideos(normalizedVideos);

      if (normalizedVideos.length > 0) {
        setSelectedVideoId(normalizedVideos[0]._id);
      } else {
        setSelectedVideoId(null);
      }
    } catch (error) {
      console.error("Failed to fetch videos:", error);
      setVideos([]);
      setSelectedVideoId(null);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    const exists = videos.some((video) => video._id === selectedVideoId);

    if (!exists) {
      setSelectedVideoId(videos[0]?._id || null);
    }
  }, [videos, selectedVideoId]);

  const selectedIndex = useMemo(
    () => videos.findIndex((video) => video._id === selectedVideoId),
    [videos, selectedVideoId]
  );

  const selectedVideo = selectedIndex >= 0 ? videos[selectedIndex] : null;

  function handlePrev() {
    if (selectedIndex > 0) {
      setSelectedVideoId(videos[selectedIndex - 1]._id);
    }
  }

  function handleNext() {
    if (selectedIndex < videos.length - 1) {
      setSelectedVideoId(videos[selectedIndex + 1]._id);
    }
  }

  return (
    <section>
      <h2 className="page-title">Guest Speaker Videos</h2>
      <p className="page-intro">
        Watch past guest speakers and browse the video library.
      </p>

      {loading ? (
        <p className="page-intro">Loading videos...</p>
      ) : (
        <>
          {fetchError && (
            <p className="status-message status-error" style={{ marginBottom: "1rem" }}>
              Could not load videos. Please refresh the page.
            </p>
          )}

          <div className="video-layout">
        <div>
          <VideoPlayer
            selectedVideo={selectedVideo}
            onPrev={handlePrev}
            onNext={handleNext}
            hasPrev={selectedIndex > 0}
            hasNext={selectedIndex < videos.length - 1}
          />
        </div>

        <div>
          <VideoList
            videos={videos}
            selectedVideoId={selectedVideoId}
            onSelect={setSelectedVideoId}
            onDelete={() => {}}
            isAdmin={false}
          />
        </div>
          </div>
        </>
      )}
    </section>
  );
}